import { GetStaticPropsContext } from "next";
import { Menu } from "@lib/menu";
import { fetchMenu } from "@lib/frontend/menus";
import { StrapiMenus } from "@lib/strapi/menus";

export interface HeaderProps {
  menu: Menu;
  /** opens the callback dialog — supplied by Layout, not by the data layer */
  showBookAppointmentModal?: () => void;
}

/**
 * The main menu comes from the seeded CMS menu-struct, not a hardcoded struct
 * (the v4 site kept navigation in lib/utils/menu.ts, so adding a page meant a
 * deploy). It is guaranteed present by the boot seed, so a miss is a data
 * problem that should fail the build loudly rather than silently render an
 * empty navigation.
 */
export const getMainMenuProps = async (
  context: GetStaticPropsContext
): Promise<HeaderProps> => {
  const cmsMenu = await fetchMenu(context, StrapiMenus.mainMenu);
  if (!cmsMenu) {
    throw new Error(
      `main menu (${StrapiMenus.mainMenu}) is not seeded in the CMS for locale "${context.locale}"`
    );
  }
  return { menu: cmsMenu };
};
